import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import http from "utils/api";
import { DATA_LIMIT } from "utils/api";
import formData from "utils/formData";

const id = localStorage.getItem("id");

const header = {
    enctype: "multipart/form-data",
    headers: {
        "Content-Type": "multipart/form-data",
        "Content-Disposition": "form-data",
    },
};

export const createAndUpdateFunction = createAsyncThunk(
    "createAndUpdateFunction",
    async ({ data, method, URL, form }) => {
        try {
            const formdata = formData(data);
            var temp = method ? http.post : http.put;
            const dato = await temp(URL, form ? formdata : data, form ? header : "").catch((err) => toast.error(err.response.data.message));
            if (dato) {
                toast.success(dato?.data?.message);
                return dato.data;
            } else {
                toast.error(dato.response.data.message);
            }
        } catch (error) {
            toast.error(error?.message);
        }
    }
);

export const getApi = createAsyncThunk(
    "getApi",
    async (url) => {
        const data = await http.get(url).catch((err) => toast.error(err.message));
        return data.data;
    }
);

export const getCategoryData = createAsyncThunk(
    "getCategoryData",
    async (url) => {
        const data = await http.get(`getAllCategories?limit=${DATA_LIMIT}`).catch((err) => toast.error(err.message));
        return data.data;
    }
);
export const getLocationData = createAsyncThunk(
    "getLocationData",
    async (url) => {
        if(id){
        const data = await http.get(`allLocations/${id}?limit=${DATA_LIMIT}`).catch((err) => toast.error(err.message));
        return data.data;
    }
    }
);

export const getAmenitiesData = createAsyncThunk(
    "getAmenitiesData",
    async (categoryId) => {
      
        const data = await http.get(`amenities?categoryId=${categoryId}&limit=${500}`).catch((err) => toast.error(err.message));
        return data.data;
    }
);
export const getKeywordsData = createAsyncThunk(
    "getKeywordsData",
    async (categoryId) => {
        const data = await http.get(`filterKeywords?categoryId=${categoryId}&limit=${500}`).catch((err) => toast.error(err.message));
        return data.data;
    }
);

export const getSubCategoryData = createAsyncThunk(
    "getSubCategoryData",
    async (id) => {
        const data = await http.get(`subcategories/${id}`).catch((err) => toast.error(err.message));
        return data.data;
    }
);
export const ChangeThemeOnRedux = createAsyncThunk(
    "ChangeThemeOnRedux",
    async (theme) => {
        return theme;
    }
);




const commonSlice = createSlice({
    name: "commonSlice",
    initialState: {
       category: [],
       amenities: [],
       subCategory: [],
       locations:[],
       keywords:[],
       theme : "dark"
    },
    reducers: {},
    
    extraReducers: (builder) => {
        builder.addCase(createAndUpdateFunction.fulfilled, (state, action) => {
            return action.payload;
        });
        builder.addCase(getApi.fulfilled, (state, action) => {
            return action.payload;
        });
        builder.addCase(getCategoryData.fulfilled, (state, action) => {
            state.category = action.payload?.data;
        });
        builder.addCase(getAmenitiesData.fulfilled, (state, action) => {
            state.amenities = action.payload?.data;
        });
        builder.addCase(getSubCategoryData.fulfilled, (state, action) => {
            state.subCategory = action.payload?.data;
        });
        builder.addCase(getLocationData.fulfilled, (state, action) => {
            state.locations = action.payload?.data;
        });
        builder.addCase(getKeywordsData.fulfilled, (state, action) => {
            state.keywords = action.payload?.data;
        });
        builder.addCase(ChangeThemeOnRedux.fulfilled, (state, action) => {
            state.theme = action.payload;
        });

    },
});

export default commonSlice.reducer;
